//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import { objectsConstants } from '../../_constants/objects.constants';
import { tableHelper } from '../../_helpers/tableHelper';
import { empresaFinanceiroService } from '../../_services/empresaFinanceiro.service';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import ListagemPage from '../../components/templates/ListagemPage';
import TopoListagem from '../../components/Topo/TopoListagem';
import EmpresaFinanceiroListFilter from './EmpresaFinanceiroListFilter';

const columns = [
  {
    path: 'id',
    pathFilter: 'id',
    title: 'Código da empresa',
    isKey: true,
    dataSort: true,
    className: 'column-bold',
    hidden: true
  },
  {
    path: 'nome',
    pathFilter: 'nome',
    title: 'Nome da empresa',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    width: '40%',
  },
  {
    path: 'dominio',
    pathFilter: 'dominio',
    title: 'Domínio',
    isKey: false,
    dataSort: true,
    width: '30%',

  },
  {
    path: 'origem',
    pathFilter: 'origem',
    title: 'Origem do registro',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    isOrigem: true
  },

  {
    path: 'bloqueadoFencom',
    pathFilter: 'bloqueadoFencom',
    title: 'Bloqueio Fencom',
    dataSort: true,
    yesNo: true,
    width: '20%',
  },
];

const endPoint = '/empresaFinanceiro/novo';
const endPointView = '/empresaFinanceiro/view/';
class EmpresaFinanceiroListage extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);
    let fields = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );
    let labels = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );
    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    this.props.history.push(endPointView + row.id);
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);

  };

  render() {
    const tableColumn = _.map(columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={objectsConstants.TITULO_PAGINA_EMPRESAS}
          subTitle=" "
          canBack={false}
        />

        <TopoListagem
          securityActionDo={objectsConstants.VIEW}
          securityActionOn={objectsConstants.CRUD_EMPRESA_EDITAR}
          buttonActionClassName={'btn-light'}
          buttonAction={() => {
            this.handleNewButton();
          }}
          securityActionIcon={'icon-btn-add'}
          securityActionName={'Nova empresa'}
        ></TopoListagem>
        <ListagemPage
          title={`Empresas`}
          showNewButton={false}
          delete={() => { }}
          service={empresaFinanceiroService}
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={EmpresaFinanceiroListFilter}
          fields={this.state.fields}
          controller="api/empresa"
          labels={this.state.labels}
          columns={columns}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(EmpresaFinanceiroListage);
